// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EQ-z","hovered":"FQ-z","hoverImage":"GQ-z","mainImage":"HQ-z","imageNoBackground":"IQ-z","fullSizeImage":"JQ-z"};